export default "__VITE_ASSET__BHJPKR_m__"